function getHexToRgb(hex) {

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}


export default function getTextColor(color) {
  
  if (!color) return 'inherit';

  let inputToRGBValues;

  if (color.startsWith('rgba(')) inputToRGBValues = color.substring(5, color.indexOf(')')).split(",").map(x => parseInt(x));
  if (color.startsWith('rgb(')) inputToRGBValues = color.substring(4, color.indexOf(')')).split(",").map(x => parseInt(x));
  if (color.startsWith('#')) {
    const hexToRgb = getHexToRgb(color)

    inputToRGBValues = hexToRgb ? [hexToRgb.r, hexToRgb.g, hexToRgb.b] : [0, 0, 0];

  }

  const colorSum = Math.round(((parseInt(inputToRGBValues[0]) * 299) + (parseInt(inputToRGBValues[1]) * 587) + (parseInt(inputToRGBValues[2]) * 114)) /1000);
  return ((colorSum > 125) ? ('#000') : ('#fff'));
}
